import { BreadcrumbsService } from './../../../../services/cms/breadcrumbs.service';
import { Breadcrumbs } from './../../../../models/cms/breadcrumbs';
//Angular
import { Component, OnInit, OnDestroy, ViewContainerRef, ComponentFactory, ReflectiveInjector, Compiler, Inject, Renderer } from "@angular/core";
import { Router, ActivatedRoute } from '@angular/router';

//Services
import { LanguageService } from "./../../../../services/cms/language.service";
import { ArticleService } from "./../../../../services/cms/article.service";
import { ComponentHelperService } from "./../../../../services/core/component-helper.service";
import { TemplateService } from "./../../../../services/settings/template.service";
import { SeoService } from "./../../../../services/core/seo.service";
import { ScriptService } from "./../../../../services/cms/script.service";
import { HelperService } from "./../../../../services/core/helper.service";

//Models
import { SeoViewModel } from "./../../../../models/core/seo";
import { NewsDetails, ArticleCategory } from "./../../../../models/cms/news-list";
import { NewsletterService } from "../../../../services/cms/newsletter.service";
import { RoutesService } from "../../../../services/core/routes.service";

import { Subscription } from 'rxjs/Subscription';
import { DOCUMENT } from '@angular/platform-browser';

@Component({
    template: ""
})

export class ArticleComponent implements OnInit {
    newsDetails: NewsDetails = new NewsDetails();

    constructor(
        private _elementRef: ViewContainerRef,
        private _compiler: Compiler,
        private componentHelper: ComponentHelperService,
        private languageService: LanguageService,
        private router: Router,
        private route: ActivatedRoute,
        private articleService: ArticleService,
        private templateService: TemplateService,
        @Inject('isBrowser') private isBrowser: boolean,
        private seo: SeoService,
        private renderer: Renderer,
        @Inject(DOCUMENT) private document: any,
        private scriptService: ScriptService) {
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    }

    subManager = new Subscription();

    ngOnInit() {
        //Reading Language information
        let lang: string = this.languageService.getLongLang();

        let paramSub = this.route.params.subscribe(params => {

            let id = params['id'];

            //Reading id from url
            //If id is set, then the page is retrived by id, else by url
            if (id !== undefined) {

                let Id: number = id;

                let subArticleId = this.articleService.getArticleDetails(Id, lang).subscribe(result => {
                     if (result.SeoInformation) {
                result.SeoInformation.ShortDescription = result.ShortDescription ? result.ShortDescription : '';
                result.SeoInformation.LongDescription = result.LongDescription ? result.LongDescription : '';
            }
                    
                    if (this.isBrowser) {
                        this.onGetPageSuccess(result);
                    }
                    else {
                        //-- Get head and body scripts
                        this.scriptService.setupExternalScripts(result, this.scriptService.typeArticle, Id);

                        //-- Setting SEO data for server side rendering, so it is visible for indexers and crawlers
                        this.seo.setSeoMetaData(this.document, this.renderer, result.SeoInformation)
                        this.seo.generateSeoDomServerSide(this.document, this.renderer, result.SeoInformation);
                    }
                });

                this.subManager.add(subArticleId);
            }

            else {
                let url = this.router.url;

                let subArticleUrl = this.articleService.getArticleByUrl(lang, url).subscribe(result => {
                    if (this.isBrowser) {
                        this.onGetPageSuccess(result);
                    }
                    else {
                        //-- Get head and body scripts
                        this.scriptService.setupExternalScripts(result, this.scriptService.typeArticle , result.Id);
                        
                        //-- Setting SEO data for server side rendering, so it is visible for indexers and crawlers
                        this.seo.setSeoMetaData(this.document, this.renderer, result.SeoInformation)
                        this.seo.generateSeoDomServerSide(this.document, this.renderer, result.SeoInformation);
                    }
                });

                this.subManager.add(subArticleUrl);
            }
        });

        this.subManager.add(paramSub);
    }

    ngOnDestroy() {
        this.subManager.unsubscribe();
    }

    onGetPageSuccess(newsResult: NewsDetails) {
        ////Creating sub-component with the returned information
        let subComponent = this.createSubComponent(newsResult);

        ////Injecting dynamically created component (OK)
        this.componentHelper.injectComponent(this._compiler, this._elementRef, subComponent);
    }

    private createSubComponent(newsObj: NewsDetails) {
        if (newsObj.Id == 0) {
            let templateSub = this.templateService.getComponentTemplate("newsletterConfirmationTemplate").subscribe(result => {
                newsObj.TemplateHtml = result;
            });

            this.subManager.add(templateSub);
        }

        @Component({
            template: newsObj.TemplateHtml
        })

        class ChildComponent implements OnInit {
            constructor(
                private seoService: SeoService,
                @Inject('isBrowser') private isBrowser: boolean,
                private _elementRef: ViewContainerRef,
                private scriptService: ScriptService,
                private helperService: HelperService,
                private newsletterService: NewsletterService,
                private routeService: RoutesService,
                private articleService: ArticleService,
                private languageService: LanguageService,
                private breadcrumbsService: BreadcrumbsService
            ) { }

            newsDetails: NewsDetails = newsObj;
            slidesNews: any = newsObj.SliderImages;
            items: any;
            category: any;
            private pageIsInit: boolean = false;
            private seoInfo: SeoViewModel = newsObj.SeoInformation;
            private model =
                {
                    Email: "",
                    Checkbox: false
                }

            private newsletterSubmittedArticle: boolean;
            private spinnerNewslatterArticle: boolean;
            private alreadySubscribedArticle: boolean;
            private successfullySubscribedArticle: boolean;
            private privacyPageNameArticle: string[] = this.routeService.getRoutePath('INFO PRIVACY');

            articleCategories: Array<ArticleCategory>;
            lang: string = this.languageService.getLongLang();
            categoryId: number = 0;
            startRowIndex: number = 0;
            maxRows: number = 999999;
            blogPageName: string[] = [];
            homePageName: string[] = [];

            private breadcrumbs: Breadcrumbs[] = newsObj.BreadcrumbsInfo;

            subManager = new Subscription();

            ngOnInit() {
                setTimeout(x => this.breadcrumbsService.setBreadcrumbs(this.breadcrumbs), 1);
                this.articleCategories = newsObj.ArticleCategories;
                this.blogPageName = this.routeService.getRoutePath('BLOG');
                this.homePageName = this.routeService.getRoutePath('HOME');
            }

            ngAfterViewChecked() {
                if (!this.isBrowser || this.pageIsInit) {
                    return;
                }

                //-- Set title, setup google analytics and other libraries 
                this.scriptService.setGoogleScripts(this.seoInfo);
                
                this.setupSocialNetworks();

                //hiding of loading panel after we get all data we need
                this.routeService.hidePageLoader();

                layoutTheme.initCarousel();
                layoutTheme.initLightbox();

                this.pageIsInit = true;
            }

            setupSocialNetworks() {
                let shareurl = window.location.href;

                let title = this.newsDetails.Title;
                let text = encodeURI(title);

                /********************************** SET THIS PART DYNAMICALY **************************************** */
                //setting twitter profile name 
                let companyTwitterProfile = "DynamicsoftSrl";

                //setting linkedin profile name
                let companyLinkedinProfile = "DynamicsoftSrl"
                /**************************************************************************************************** */
                //encoded current page
                let currentPage = encodeURI(shareurl);
                //sharing of current page on Facebook
                $('.fbsharelink').click(function () {
                    window.open('https://www.facebook.com/sharer/sharer.php?u=' + shareurl + '&t=' + document.title, '',
                        'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600');
                    return false;
                });

                //sharing of current page on LinkedIn
                $('.linkedinsharelink').click(function () {
                    window.open('https://www.linkedin.com/shareArticle?mini=true&url=' + shareurl + '&title=' + document.title +
                        '&summary=' + text + '&source=' + companyLinkedinProfile, '',
                        'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600')
                });

                //sharing of currentpage on Twitter
                $('.twitter-share-button').click(function () {
                    window.open('https://twitter.com/intent/tweet?text=' + text + '&url=' + currentPage + '&via=' + companyTwitterProfile, '',
                        'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600');
                })
            }

            onSubmit(form) {
                this.spinnerNewslatterArticle = true;
                if (form) {
                    let subNewsletter = this.newsletterService.newsletterSubscribe(this.model.Email).subscribe(result => {

                        if (result == "-1") {
                            this.alreadySubscribedArticle = true;
                            this.successfullySubscribedArticle = false;
                            this.spinnerNewslatterArticle = false;
                        }

                        else {
                            this.alreadySubscribedArticle = false;
                            this.successfullySubscribedArticle = true;
                            this.spinnerNewslatterArticle = false;
                        }
                    });

                    this.subManager.add(subNewsletter);
                }

                else {
                    this.spinnerNewslatterArticle = false;
                }
            }

            imageTitle(imgPath) {
                let imgName = this.helperService.GetFileNameFromPath(imgPath);
                return imgName;
            }

            ngOnDestroy() {
                //Called once, before the instance is destroyed.
                //Add 'implements OnDestroy' to the class.
                this.subManager.unsubscribe();
            }
        }

        return ChildComponent;
    }
}


// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/components/cms/article/sys/news-page.component.ts